import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import { App } from './app/app';
import { appConfig } from './app/app.config';

declare const userPoolId: string;
declare const userPoolClientId: string;
declare const cognitoDomain: string;
declare const redirectSignIn: string;
declare const redirectSignOut: string;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: userPoolId,
      userPoolClientId: userPoolClientId,
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn: [redirectSignIn],
          redirectSignOut: [redirectSignOut],
          responseType: 'code' 
        }
      }
    }
  }
});

bootstrapApplication(App, appConfig)
  .catch(err => console.error(err));
